import { CheckCircle2, AlertTriangle, Lock, XCircle } from "lucide-react";

const MAP = {
  calcolabile: { label: "Calcolabile", cls: "bg-emerald-100 text-emerald-800 border-emerald-200", Icon: CheckCircle2 },
  calcolabile_warning: { label: "Con Warning", cls: "bg-amber-100 text-amber-800 border-amber-200", Icon: AlertTriangle },
  riservato_direzione: { label: "Riservato Direzione", cls: "bg-orange-100 text-orange-800 border-orange-200", Icon: Lock },
  non_ammissibile: { label: "Non Ammissibile", cls: "bg-rose-100 text-rose-800 border-rose-200", Icon: XCircle },
  draft: { label: "Bozza", cls: "bg-stone-100 text-stone-600 border-stone-200", Icon: AlertTriangle },
  emailed: { label: "Inviato", cls: "bg-blue-100 text-blue-800 border-blue-200", Icon: CheckCircle2 },
};

export default function OutcomeBadge({ status, size = "sm" }) {
  const m = MAP[status] || MAP.draft;
  const { Icon } = m;
  return (
    <span
      data-testid={`outcome-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 font-semibold uppercase tracking-wide ${m.cls} ${
        size === "lg" ? "text-sm px-3 py-1" : "text-[11px]"
      }`}
    >
      <Icon className={size === "lg" ? "w-4 h-4" : "w-3 h-3"} strokeWidth={1.5} />
      {m.label}
    </span>
  );
}
